import { Component } from '@angular/core';
import { ChangesObjectType, UpdatedChanges } from 'icreate/common/models/versions-history';

@Component({
    selector: 'app-version-history-changes-panel',
    template: '',
    styleUrls: ['./version-history-changes-panel.component.css'],
    standalone: false,
})
export class VersionHistoryChangesPanelComponent {
    colors: { [name: string]: string } = {};

    getStringColor(name) {
        return this.colors[name];
    }

    hasAdded(change: { key: string; value: string[] }): boolean {
        return change.key === ChangesObjectType.ADDED && change.value?.length > 0;
    }

    hasDeleted(change: { key: string; value: string[] }): boolean {
        return change.key === ChangesObjectType.DELETED && change.value?.length > 0;
    }

    hasUpdated(change: { key: string; value: UpdatedChanges }): boolean {
        return change.key === ChangesObjectType.UPDATED && Object.keys(change.value)?.length > 0;
    }
}
